import './css/styles.scss';

// import Swiper JS
import Swiper from 'swiper';
// import Swiper and modules styles
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const initHeroSwiper = function() {
    const heroSwiper = document.querySelector('#heroSwiper');
	if (!heroSwiper) return;

	const slides = heroSwiper.querySelectorAll('.swiper-slide');
	if (!slides.length) return;

	const playPauseButton = document.querySelector('#playPauseButton'); // The Play/Pause button
	const playIcon = '/app/themes/lindstrad/assets/img/play-icon.svg'; // The Play SVG
	const pauseIcon = '/app/themes/lindstrad/assets/img/paus-icon.svg'; // The Pause SVG
    //const playPauseIcon = document.querySelector('#playPauseIcon'); // The <img> element that displays the SVG

	const swiper = new Swiper('#heroSwiper', {
		// configure Swiper to use modules
		modules: [Pagination, Autoplay],
		slidesPerView: 1,
		slidesPerGroup: 1,
		autoHeight: false,
		effect: 'fade',
		loop: true,
		speed: 1000,
		autoplay: {
            delay: 3000,//animation speed
			disableOnInteraction: false // Make sure autoplay resumes after interaction
        },
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + '<em>'+'</em>' + '<i></i>' + '<b></b>'  + '</span>';
              },
        },               
		
	});

	// Handle Play/Pause button click
    let isPlaying = true;
	if (!playPauseButton) return;
    playPauseButton.addEventListener('click', function() {
        const activeSlide = heroSwiper.querySelector('.swiper-slide-active');
        const video = activeSlide.querySelector('video'); // Find the video in the active slide
		let playPauseIcon = playPauseButton.querySelector('img#playPauseIcon') as HTMLImageElement; // Cast to HTMLImageElement

        if (isPlaying) {
            swiper.autoplay.stop(); // Pause the autoplay
            if (video) video.pause(); // Pause the video if it exists
			if (playPauseIcon) playPauseIcon.src = playIcon; // Change to Play SVG
			
			
        } else {
            swiper.autoplay.start(); // Start the autoplay
            if (video) video.play(); // Play the video if it exists
			if (playPauseIcon) playPauseIcon.src = pauseIcon; // Change to Play SVG
        }
        isPlaying = !isPlaying; // Toggle play/pause state
    });
};


// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	initHeroSwiper();
});

